import { PaperClipOutlined } from "@ant-design/icons";
import { downloadData } from "aws-amplify/storage";
import React from 'react';
import { downloadBlob } from "../../../../../util/varibles/global";
import stylesContainer from "../../style.module.scss";
import styles from "./style.module.scss";

interface IProps {
    files: any
}

const AttachFile: React.FC<IProps> = ({ files }) => {
    const handleOpenFile = (file: any) => {
        const { isNew, name } = file;
        if (isNew) {
            const element = document.createElement("a");
            element.href = URL.createObjectURL(file.file);
            element.download = name;
            document.body.appendChild(element); // Required for this to work in FireFox
            element.click();
            element.remove();
        } else {
            const { key } = file;
            downloadData({ path: `public/operations/${key}` }).result
                .then(result => result.body.blob())
                .then(blob => downloadBlob(blob, name))
        }
    }

    if (files.length === 0)
        return null;

    return <div className={[stylesContainer['container-box'], 'mb-10'].join(' ')}>
        <PaperClipOutlined />
        <div>Attached files:</div>
        <div className='ml-5'>
            {files.map((item: any) =>
                <div key={item.key} className={styles['file']} onClick={() => handleOpenFile(item)}>
                    {item.name}
                </div>)}
        </div>
    </div>;

}

export default AttachFile;